let currency = 'USD';

export function setCurrency(code: string) {
  currency = code;
}

/** Format integer cents as currency. */
export function money(cents: number, digits = 0): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(cents / 100);
}

export const esc = (s: unknown) =>
  String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);

/** Round cents up to the next $5. */
export const roundUp5 = (cents: number) => Math.ceil(cents / 500) * 500;

/** Parse "$1,234.50" style input into cents, or NaN. */
export function parseCents(input: string): number {
  const n = parseFloat(String(input).replace(/[$,\s]/g, ''));
  return Number.isFinite(n) ? Math.round(n * 100) : NaN;
}

const utc = (year: number, month: number, day: number) => new Date(Date.UTC(year, month - 1, day));

export const monthName = (year: number, month: number) =>
  utc(year, month, 1).toLocaleDateString('en-US', { month: 'long', timeZone: 'UTC' });

export const monthShort = (year: number, month: number) =>
  utc(year, month, 1).toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' });

export const dayLabel = (iso: string) => {
  const [y, m, d] = iso.split('-').map(Number);
  return utc(y, m, d).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', timeZone: 'UTC' });
};

export const shortDate = (iso: string) => {
  const [y, m, d] = iso.split('-').map(Number);
  return utc(y, m, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
};

export const dayOf = (iso: string) => Number(iso.slice(8, 10));

export const isoDay = (month: string, day: number) => `${month}-${String(day).padStart(2, '0')}`;

/** "Aug 2027" from "2027-08". */
export const monthYear = (month: string) => {
  const [y, m] = month.split('-').map(Number);
  return utc(y, m, 1).toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' });
};

/** "Mar 15, 2026". */
export const fullDate = (iso: string) => {
  const [y, m, d] = iso.split('-').map(Number);
  return utc(y, m, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
};

/** Dollars with cents only when there are some: "$180", "$179.99". */
export const plainMoney = (cents: number) => money(cents, cents % 100 ? 2 : 0);
